import Layout from '../../components/Layout/Layout';
import { buildPrimaryPostPage } from '../../util/buildPrimaryPostPage';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'BRANDS',
        LayoutComponent: Layout,
        pathFormatter: (slug) => slug.join('/'),
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
